import React, { useState } from 'react';
import Diamond from './Diamond';

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Smart scroll to booking/pricing section
  const handleBookNowClick = (e) => {
    e.preventDefault();
    setMobileMenuOpen(false);
    
    // Try to find pricing section first (Binary Finance page), then book-session (homepage)
    const pricingSection = document.getElementById('pricing');
    const bookSection = document.getElementById('book-session');
    
    if (pricingSection) {
      pricingSection.scrollIntoView({ behavior: 'smooth' });
    } else if (bookSection) {
      bookSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header data-testid="site-header" className="header-wrapper">
      <div 
        className="section py-5 flex items-center justify-between header-inner"
        style={{ maxWidth: 'var(--max-width)', margin: '0 auto' }}
      >
        <a 
          href="/" 
          className="flex items-center gap-2 no-underline"
          data-testid="logo-link"
        >
          <Diamond color="blue" size="sm" />
          <span 
            style={{ 
              fontFamily: 'var(--font-display)',
              fontWeight: 700,
              fontSize: '16px',
              letterSpacing: '0.02em',
              color: 'var(--color-near-black)'
            }}
          >
            BINARY GAME
          </span>
        </a>
        
        {/* Desktop Navigation */}
        <div className="header-nav-desktop flex items-center gap-4">
          <a 
            href="#arcade"
            style={{ 
              fontFamily: 'var(--font-mono)',
              fontSize: '11px',
              color: 'var(--color-mid)',
              textDecoration: 'none',
              letterSpacing: '0.05em'
            }}
            data-testid="header-arcade"
          >
            THE ARCADE
          </a>
          <a 
            href="/binary-finance"
            style={{ 
              fontFamily: 'var(--font-mono)',
              fontSize: '11px',
              color: 'var(--color-mid)',
              textDecoration: 'none',
              letterSpacing: '0.05em'
            }}
            data-testid="header-binary-finance"
          >
            BINARY FINANCE
          </a>
          <a 
            href="/login"
            style={{ 
              fontFamily: 'var(--font-mono)',
              fontSize: '11px',
              color: 'var(--color-mid)',
              textDecoration: 'none',
              letterSpacing: '0.05em'
            }}
            data-testid="header-login"
          >
            LOGIN
          </a>
          <button 
            onClick={handleBookNowClick}
            className="btn-yes"
            style={{ fontSize: '12px', padding: '10px 18px', cursor: 'pointer' }}
            data-testid="header-cta"
          >
            <Diamond color="white" size="sm" />
            Book Now
          </button>
        </div>

        {/* Mobile Hamburger Button */}
        <button 
          className="header-hamburger"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
          data-testid="header-hamburger"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            {mobileMenuOpen ? (
              <>
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </>
            ) : (
              <>
                <line x1="3" y1="6" x2="21" y2="6"/>
                <line x1="3" y1="12" x2="21" y2="12"/>
                <line x1="3" y1="18" x2="21" y2="18"/>
              </>
            )}
          </svg>
        </button>
      </div>
      
      {/* Mobile Menu Dropdown */}
      {mobileMenuOpen && (
        <div className="header-mobile-menu">
          <a 
            href="#arcade"
            onClick={() => setMobileMenuOpen(false)}
            data-testid="mobile-arcade"
          >
            THE ARCADE
          </a>
          <a 
            href="/binary-finance"
            onClick={() => setMobileMenuOpen(false)}
            data-testid="mobile-binary-finance"
          >
            BINARY FINANCE
          </a>
          <a 
            href="/login"
            onClick={() => setMobileMenuOpen(false)}
            data-testid="mobile-login"
          >
            LOGIN
          </a>
          <button 
            onClick={handleBookNowClick}
            className="header-mobile-cta"
            style={{ cursor: 'pointer', border: 'none' }}
            data-testid="mobile-cta"
          >
            <Diamond color="white" size="sm" />
            Book Now
          </button>
        </div>
      )}
      
      <hr className="minor" style={{ maxWidth: 'var(--max-width)', margin: '0 auto' }} />
    </header>
  );
};

export default Header;
